import React, {useState, setGlobal, getGlobal, useEffect} from 'reactn';
import { Radio, Checkbox, Button, Skeleton, Switch, notification, Popover, Tabs} from 'antd';
import {useParams} from 'react-router-dom';
import { useFirestore } from 'reactfire';

const HistoryOfNasalSymptomsWithComplication = (props) => {
    
    const [isHistoryOfNasalSymptomsWithComplication, setHistoryOfNasalSymptomsWithComplication] = useState('No');
    let { appointmentId } = useParams();
    const [popup, setPopup] = useState(false);
    const firestore = useFirestore();

    const [state, setState] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);
    
    const getSelectedFields = (event) => {
        setState({
            ...state,
            [event.target.name] : event.target.value
        });
    }

    useEffect(() => {
        // if (!getGlobal().hasFetchedChiefComplaints) {
        // }
        getCurrentCCLocation();
    }, [props]);

    const getCurrentCCLocation = () => {

        let records = [];
        setLoading(true);
        firestore.collection("ChiefComplaints").where("appointment_id", "==", appointmentId).get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                records.push({data: doc.data(), id: doc.id});
            });
        }).finally(() => {
            if (records.length> 0 && records[0].data && records[0].data.ChiefComplaints_location && records[0].data.ChiefComplaints_location.Nasal && records[0].data.ChiefComplaints_location.Nasal.HistoryOfNasalSymptomsWithComplication) {
                let thisObj = records[0].data.ChiefComplaints_location.Nasal.HistoryOfNasalSymptomsWithComplication;
                setState(thisObj ? thisObj : {});
                setHistoryOfNasalSymptomsWithComplication(thisObj ? 'Yes' : 'No');
                if (!thisObj) {
                    assignDefaultValues();
                }
            } else {
                assignDefaultValues();
            }

            setLoading(false);
        });

    }

    const assignDefaultValues = () => {
        if (!state) {
            assignDefaultValuesAnyways();
        }
    }

    const assignDefaultValuesAnyways = () => {
        setState({
            'Orbital Complications' : 'No complication',
            'Ear Symptoms' : 'No Symptoms',
            'Smell' : 'No Symptoms',
            'Throat' : 'No Symptoms',
            'Systemic Symptoms' : 'No Symptoms'

        });
    }

    const getCheckBoxONChange = (value, target) => {
        setState({
            ...state,
            [target] : value
        });
    }

    const saveTheForm = () => {
        setLoadingBtn(true);
        let previosuValues = {};
        if (getGlobal().ChiefComplaints_location) {
            previosuValues = {...getGlobal().ChiefComplaints_location};
        } else {
            previosuValues = {}
        }
        let objectToSave = {
            ...previosuValues,
            'Nasal': {
                ...previosuValues.Nasal,
                'HistoryOfNasalSymptomsWithComplication' : {'isHistoryOfNasalSymptomsWithComplication': isHistoryOfNasalSymptomsWithComplication, ...state}
            }
        }


        if (getGlobal().ChiefComplaints_location_id) {
            firestore.collection('ChiefComplaints').doc(getGlobal().ChiefComplaints_location_id).update({
                ChiefComplaints_location: objectToSave,
            }).then(() => {
                notification.open({
                    message: 'Record Successfully Updated',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).catch(() => {
                notification.open({
                    message: 'An Error Occured',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).finally(() => {
                props.hasSaved();
                setLoadingBtn(false);
            });
        } else {
            firestore.collection('ChiefComplaints').add({
                patient: firestore.collection("patients").doc(getGlobal().patientID),
                appointment: firestore.collection("appointments").doc(getGlobal().appointmentId),
                appointment_id: getGlobal().appointmentId,
                date: new Date(),
                ChiefComplaints_location: objectToSave,
            }).then(() => {
                notification.open({
                    message: 'Record Successfully Added',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).catch(() => {
                notification.open({
                    message: 'An Error Occured',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).finally(() => {
                props.hasSaved();
                setLoadingBtn(false);
            });
        }
  

        
    }

    const deleteHistoryOfNasalSymptomsWithComplication = () => {

        let previosuValues = {};
        if (getGlobal().ChiefComplaints_location) {
            previosuValues = {...getGlobal().ChiefComplaints_location};
        } else {
            previosuValues = {}
        }
        let objectToDelete = {
            ...previosuValues,
            'Nasal': {
                ...previosuValues.Nasal,
                'HistoryOfNasalSymptomsWithComplication' : null
            }
        }
        firestore.collection('ChiefComplaints').doc(getGlobal().ChiefComplaints_location_id).update({
            ChiefComplaints_location: objectToDelete,
            
        }).then(() => {
            notification.open({
                message: 'Record Successfully Delete',
                // icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
            setGlobal({ChiefComplaints_location: {...getGlobal().ChiefComplaints_location.Nasal, HistoryOfNasalSymptomsWithComplication: null}})
            setPopup(!popup)
            props.hasSaved();
            assignDefaultValuesAnyways();
        }).catch(() => {
            notification.open({
                message: 'An Error Occured',
                // icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
        });


      
    }




    const HistoryOfNasalSymptomsWithComplicationSelect = (event) => {
        setHistoryOfNasalSymptomsWithComplication(event.target.value);
    }



    return (
        <div>
            <React.Fragment>
            {loading ? <Skeleton active /> : <>
            <Radio.Group value={isHistoryOfNasalSymptomsWithComplication} onChange={HistoryOfNasalSymptomsWithComplicationSelect} buttonStyle="solid" size="large" style={{marginTop: '20px'}}>
                    <Radio.Button value={'Yes'}>Yes</Radio.Button>
                    
                    <Popover
                        content={<a onClick={deleteHistoryOfNasalSymptomsWithComplication}>Delete</a>}
                        title="Are you sure you want to delete All Record of HistoryOfNasalSymptomsWithComplication?"
                        trigger="click"
                        visible={popup}
                        onVisibleChange={() => {
                            if(getGlobal().ChiefComplaints_location.Nasal && getGlobal().ChiefComplaints_location.Nasal.HistoryOfNasalSymptomsWithComplication){setPopup(!popup)}
                        }}
                    >
                        {/* <DeleteOutlined /> */}
                        <Radio.Button value={'No'}>No</Radio.Button>

                        
                    
                    </Popover>

                </Radio.Group>
               
               {isHistoryOfNasalSymptomsWithComplication === 'Yes' && <Button className="SaveFormButton" loading={loadingBtn} style={{float: 'right'}} onClick={saveTheForm} type="primary">Save</Button>}
  
               {isHistoryOfNasalSymptomsWithComplication === 'Yes' ? 

                    <ul className='showFieldsTable'>
                        <li><span>Side</span>
                            <Radio.Group name="Side" value={state && state['Side']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Left Nasal Cavity'}>Left Nasal Cavity</Radio.Button>
                                <Radio.Button value={'Right Nasal Cavity'}>Right Nasal Cavity</Radio.Button>
                                <Radio.Button value={'Bilateral'}>Bilateral</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Orbital Complications</span>
                            <Checkbox.Group name="Orbital Complications" value={state && state['Orbital Complications']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Orbital Complications')} size="large">
                                <Checkbox value="No complication" style={{ lineHeight: '32px' }}>
                                No complication
                                </Checkbox>
                                <Checkbox value="Deterioration of vision" style={{ lineHeight: '32px' }}>
                                Deterioration of vision
                                </Checkbox>
                                <Checkbox value="Redness of Eyes" style={{ lineHeight: '32px' }}>
                                Redness of Eyes
                                </Checkbox>
                                <Checkbox value="Proptosis" style={{ lineHeight: '32px' }}>
                                Proptosis
                                </Checkbox>
                                <Checkbox value="Diplopia" style={{ lineHeight: '32px' }}>
                                Diplopia
                                </Checkbox>
                                <Checkbox value="Orbital swelling" style={{ lineHeight: '32px' }}>
                                Orbital swelling
                                </Checkbox>
                                <Checkbox value="Restricted movements" style={{ lineHeight: '32px' }}>
                                Restricted movements
                                </Checkbox>
                                <Checkbox value="Painful movements" style={{ lineHeight: '32px' }}>
                                Painful movements
                                </Checkbox>
                            </Checkbox.Group>
                        </li>
                        <li><span>Ear Symptoms</span>
                            <Checkbox.Group name="Ear Symptoms" value={state && state['Ear Symptoms']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Ear Symptoms')} size="large">
                                <Checkbox value="No Symptoms" style={{ lineHeight: '32px' }}>
                                No Symptoms
                                </Checkbox>
                                <Checkbox value="Ear ache" style={{ lineHeight: '32px' }}>
                                Ear ache
                                </Checkbox>
                                <Checkbox value="Discharge" style={{ lineHeight: '32px' }}>
                                Discharge
                                </Checkbox>
                                <Checkbox value="Hearing loss" style={{ lineHeight: '32px' }}>
                                Hearing loss
                                </Checkbox>
                            </Checkbox.Group>
                        </li>

                        <li><span>Throat</span>
                            <Checkbox.Group name="Throat" value={state && state['Throat']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Throat')} size="large">
                                <Checkbox value="No Symptoms" style={{ lineHeight: '32px' }}>
                                No Symptoms
                                </Checkbox>
                                <Checkbox value="Neck Swellings" style={{ lineHeight: '32px' }}>
                                Neck Swellings
                                </Checkbox>
                                <Checkbox value="Other Swellings" style={{ lineHeight: '32px' }}>
                                Other Swellings
                                </Checkbox>
                                <Checkbox value="Anorexia" style={{ lineHeight: '32px' }}>
                                Anorexia
                                </Checkbox>
                                <Checkbox value="Weight Loss" style={{ lineHeight: '32px' }}>
                                Weight Loss
                                </Checkbox>
                            </Checkbox.Group>
                        </li>

                        <li><span>Systemic Symptoms</span>
                            <Checkbox.Group name="Systemic Symptoms" value={state && state['Systemic Symptoms']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Systemic Symptoms')} size="large">
                                <Checkbox value="No Symptoms" style={{ lineHeight: '32px' }}>
                                No Symptoms
                                </Checkbox>
                                <Checkbox value="Dysphagia" style={{ lineHeight: '32px' }}>
                                Dysphagia
                                </Checkbox>
                                <Checkbox value="Difficulty of breathing" style={{ lineHeight: '32px' }}>
                                Difficulty of breathing
                                </Checkbox>
                                <Checkbox value="Hoarseness of voice" style={{ lineHeight: '32px' }}>
                                Hoarseness of voice
                                </Checkbox>
                                <Checkbox value="Cough" style={{ lineHeight: '32px' }}>
                                Cough
                                </Checkbox>
                                <Checkbox value="Haemoptysis" style={{ lineHeight: '32px' }}>
                                Haemoptysis
                                </Checkbox>
                                <Checkbox value="Abdominal pain" style={{ lineHeight: '32px' }}>
                                Abdominal pain
                                </Checkbox>
                                <Checkbox value="Urinary complaints" style={{ lineHeight: '32px' }}>
                                Urinary complaints
                                </Checkbox>
                                <Checkbox value="Bowel complaints" style={{ lineHeight: '32px' }}>
                                Bowel complaints
                                </Checkbox>
                            </Checkbox.Group>
                        </li>
                        
                        <Button className="SaveFormButton" loading={loadingBtn} onClick={saveTheForm} type="primary">Save</Button>
                    </ul>

                    
                : ''}
                 </>}
            </React.Fragment>
 
        </div>
    );
}

export default HistoryOfNasalSymptomsWithComplication;
